import { AnalyticsEventName } from './analytics-event-name.model';

export interface AnalyticsEventModel {
  language: string;
  ['procedure_id']: string;
  ['campaign_id']: string;
  event: AnalyticsEventName;
}

export interface AnalyticsPageviewEventModel extends AnalyticsEventModel {
  page: {
    path: string;
    title: string;
  };
  http: {
    response: {
      code: string;
    };
  };
}

export interface AnalyticsPopupEventModel extends AnalyticsEventModel {
  type: string;
  popup: {
    action: string;
    elements: {
      title: string;
      content: string;
      name: string;
      cta: {
        existing: [];
        clicked: string;
      };
    };
  };
}

export interface AnalyticsCtaClickEventModel extends AnalyticsEventModel {
  cta: {
    text: string;
    class: string;
    ['target_url']: string;
  };
}

export interface AnalyticsInputFocusEventModel extends AnalyticsEventModel {
  ['input_field']: {
    label: string;
    id: string;
    class: string;
  };
}

export interface AnalyticsErrorEventModel extends AnalyticsEventModel {
  error: {
    ['error_type']: 'backend' | 'form' | 'input';
    ['error_code']: string;
    ['error_message']: string;
    ['error_field']?: string;
    ['is_fatal']: boolean;
  };
}

export interface AnalyticsOutcomeEventModel extends AnalyticsEventModel {
  request: {
    id: string;
    description: string;
  };
  response: {
    code: number;
    status: number;
    message: string;
  };
}
